import HeroSectionWithButton from "../SkillAnalytics/Components/HeroSectionWithButton";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import ShowcaseSection from "../SkillAnalytics/Components/ShowcaseSection";
import ImageAndTextSectionWithBullets from "../SkillManagement/Components/ImageTextSectionWithBullets";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { getVitrineAssesses } from "../../Store/Thunk";
import VitrineSection from "./Components/VitrineSection";
import TitleWithStar from "../../Shared/TitleWithStar";

const AssessmentLibrary = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const vitrineItems = useSelector((state) => state.landingPage.vitrineItems);

  useEffect(() => {
    dispatch(getVitrineAssesses());
  }, []);

  return (
    <div className={"p-0"}>
      <Row className={"mx-0"}>
        <TitleWithStar text={t("landing.assessmentLibrary.title")} className={"mt-3 mb-5"}></TitleWithStar>

        <VitrineSection></VitrineSection>
      </Row>
    </div>
  );
};
export default AssessmentLibrary;
